var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.changes,"headers":_vm.headers,"dense":"","items-per-page":_vm.itemsPerPage,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var headers = ref.headers;
return [_c('CRUDRow',{attrs:{"canEdit":false,"canDelete":false,"item":item,"headers":headers}})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }